import { render, staticRenderFns } from "./WeldingInspectors.vue?vue&type=template&id=dc0a40b0"
import script from "./WeldingInspectors.vue?vue&type=script&lang=js"
export * from "./WeldingInspectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports